import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

interface ContentFiltroProps {
  isSelected?: boolean;
  w?: string;
  title: string;
  onClick: React.MouseEventHandler<HTMLDivElement> | undefined;
}

export default function ContentFiltro({
  isSelected,
  onClick,
  title,
  w,
}: ContentFiltroProps) {
  const color = isSelected ? "white" : undefined;
  const bg = isSelected ? colors.blue : "white";
  return (
    <Flex
      justify="center"
      align="center"
      mt="10px"
      h="35px"
      w={w}
      flex={1}
      maxW={w}
      minW={w}
      py={2}
      px={3}
      rounded={4}
      cursor="pointer"
      bg={bg}
      color={color}
      onClick={onClick}
    >
      {title}
    </Flex>
  );
}
